// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"f22dd43d","821":"3f5c8a9b"}[chunkId] + ".chunk.js";
};